/* eslint-disable complexity */
import styled from '@emotion/styled';
import { LoadingButton } from '@mui/lab';
import { DialogTitle } from '@mui/material';
import Button from '@mui/material/Button';
import Chip from '@mui/material/Chip';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import FormControl from '@mui/material/FormControl';
import MenuItem from '@mui/material/MenuItem';
import Select from '@mui/material/Select';
import Stack from '@mui/material/Stack';
import TextField from '@mui/material/TextField';
import useProductPackagingInsert from 'api/productDetail/useProductPackagingInsert/useProductPackagingInsert';
import useGetAllProductIdentityType from 'api/productPackaging/packagingPrint/useGetAllProductIdentityType';
import useGetAllCodes from 'api/productPackaging/useGetAllCodes';
import useGetAllParentlist from 'api/productPackaging/useGetAllParentlist';
import React, { useEffect, useState } from 'react';

import SpinnerLoader from '../../../SpinnerLoader/SpinnerLoader';

const PACKAGE_NAME_TEMPLATES = [
  'بسته بندی یک عددی',
  'بسته بندی یک دستی',
  'بسته بندی 10 عددی',
];

const ProductPackagingInsertModal = ({
  open,
  branchGuid,
  handleClose,
  refetchPackagingList,
}) => {
  const [packageName, setPackageName] = useState('');
  const [description, setDescription] = useState('');
  const [packageLenght, setPackageLenght] = useState('');
  const [identityType, setIdentityType] = useState('');
  const [identityCode, setIdentityCode] = useState('');
  const [parentPack, setParentPack] = useState('');
  const [splittable, setSplittable] = useState('true');
  const [requiredScanning, setRequiredScanning] = useState('true');
  const [emptyError, setEmptyError] = useState(false);

  const [insertRequest, insertLoading] = useProductPackagingInsert();
  const [
    getAllProductIdentityType,
    getIdentityTypeLoading,
    allProductIdentityType,
  ] = useGetAllProductIdentityType();
  const [getAllParentlist, getParentListLoading, allParentlist] =
    useGetAllParentlist();
  const [getAllCodes, getAllCodesLoading, allCodes] = useGetAllCodes();

  useEffect(() => {
    getAllProductIdentityType();
    getAllParentlist({
      branchGuid,
      // packGuid
    });
    getAllCodes({ branchGuid });
  }, []);

  const allParentlistWithEmpty = [
    {
      key: '',
      value: 'هیچکدام',
    },
    ...allParentlist,
  ];

  const submitCodeGroup = () => {
    if (
      packageName &&
      packageLenght &&
      identityType &&
      splittable &&
      requiredScanning
    ) {
      setEmptyError(false);
      insertRequest({
        branchGuid,
        packageName,
        description,
        packageLenght,
        identityType,
        identityCodeGuid: identityCode,
        parentPackGuid: parentPack,
        splittable: splittable === 'true',
        requiredScanning: requiredScanning === 'true',
        handleRefetch: () => {
          handleClose();
          refetchPackagingList();
        },
      });
    } else {
      setEmptyError(true);
    }
  };

  return (
    <Dialog open={open} onClose={handleClose} sx={{ direction: 'rtl' }}>
      <DialogTitle>ثبت پکیج</DialogTitle>

      <DialogContent sx={{ width: '600px' }}>
        <FilledWrapper>
          <FilledLabel>عنوان</FilledLabel>
          <Stack
            spacing={1}
            sx={{ width: 'calc(100% - 150px)', alignItems: 'flex-start' }}
          >
            <TextField
              autoFocus
              variant="standard"
              value={packageName}
              onChange={e => setPackageName(e.target.value)}
              sx={{ width: '100%' }}
              error={!packageName && emptyError}
            />
            <Stack direction="row" gap={1} flexWrap="wrap" useFlexGap>
              {PACKAGE_NAME_TEMPLATES.map(template => (
                <Chip
                  key={template}
                  label={template}
                  variant="outlined"
                  clickable
                  onClick={() => setPackageName(template)}
                />
              ))}
            </Stack>
          </Stack>
        </FilledWrapper>

        <FilledAreaWrapper>
          <FilledLabel>توضیحات</FilledLabel>
          <TextArea
            rows="5"
            value={description}
            onChange={e => setDescription(e.target.value)}
          />
        </FilledAreaWrapper>

        <FilledWrapper>
          <FilledLabel>تعداد</FilledLabel>
          <TextField
            variant="standard"
            value={packageLenght}
            onChange={e => setPackageLenght(e.target.value)}
            sx={{ width: 'calc(100% - 150px)' }}
            error={!packageLenght && emptyError}
            type="number"
            label="عدد"
          />
        </FilledWrapper>

        <FilledWrapper>
          <FilledLabel>نوع شناسه</FilledLabel>
          <FormControl
            variant="standard"
            sx={{ width: 'calc(100% - 150px)' }}
            error={!identityType && emptyError}
          >
            <Select
              labelId="demo-simple-select-standard-label"
              id="demo-simple-select-standard"
              value={identityType}
              onChange={e => setIdentityType(e.target.value)}
            >
              {getIdentityTypeLoading ? (
                <SpinnerLoader />
              ) : (
                allProductIdentityType.map(type => (
                  <MenuItem
                    value={type.key}
                    key={type.key}
                    sx={{ direction: 'rtl' }}
                  >
                    {type.value}
                  </MenuItem>
                ))
              )}
            </Select>
          </FormControl>
        </FilledWrapper>

        {identityType === '1' ? (
          <FilledWrapper>
            <FilledLabel>انتخاب کد</FilledLabel>
            <FormControl
              variant="standard"
              sx={{ width: 'calc(100% - 150px)' }}
              error={!identityCode && emptyError}
            >
              <Select
                labelId="demo-simple-select-standard-label"
                id="demo-simple-select-standard"
                value={identityCode}
                onChange={e => setIdentityCode(e.target.value)}
              >
                {getAllCodesLoading ? (
                  <SpinnerLoader />
                ) : (
                  allCodes?.map(type => (
                    <MenuItem
                      value={type.key}
                      key={type.key}
                      sx={{ direction: 'rtl' }}
                    >
                      {type.value}
                    </MenuItem>
                  ))
                )}
              </Select>
            </FormControl>
          </FilledWrapper>
        ) : null}

        <FilledWrapper>
          <FilledLabel>بسته بندی مادر</FilledLabel>
          <FormControl variant="standard" sx={{ width: 'calc(100% - 150px)' }}>
            <Select
              labelId="demo-simple-select-standard-label"
              id="demo-simple-select-standard"
              value={parentPack}
              onChange={e => setParentPack(e.target.value)}
            >
              {getParentListLoading ? (
                <SpinnerLoader />
              ) : (
                allParentlistWithEmpty.map(type => (
                  <MenuItem
                    value={type.key}
                    key={type.key}
                    sx={{ direction: 'rtl' }}
                  >
                    {type.value}
                  </MenuItem>
                ))
              )}
            </Select>
          </FormControl>
        </FilledWrapper>

        <FilledWrapper>
          <FilledLabel>قابل خرد شدن</FilledLabel>
          <FormControl
            variant="standard"
            sx={{ width: 'calc(100% - 150px)' }}
            error={!splittable && emptyError}
          >
            <Select
              labelId="demo-simple-select-standard-label"
              id="demo-simple-select-standard"
              value={splittable}
              onChange={e => setSplittable(e.target.value)}
            >
              <MenuItem value="true" key="true" sx={{ direction: 'rtl' }}>
                بله
              </MenuItem>
              <MenuItem value="false" key="false" sx={{ direction: 'rtl' }}>
                خیر
              </MenuItem>
            </Select>
          </FormControl>
        </FilledWrapper>

        <FilledWrapper>
          <FilledLabel>اسکن اجباری</FilledLabel>
          <FormControl
            variant="standard"
            sx={{ width: 'calc(100% - 150px)' }}
            error={!requiredScanning && emptyError}
          >
            <Select
              labelId="required-scanning-select-label"
              id="required-scanning-select"
              value={requiredScanning}
              onChange={e => setRequiredScanning(e.target.value)}
            >
              <MenuItem value="true" key="true" sx={{ direction: 'rtl' }}>
                بله
              </MenuItem>
              <MenuItem value="false" key="false" sx={{ direction: 'rtl' }}>
                خیر
              </MenuItem>
            </Select>
          </FormControl>
        </FilledWrapper>
      </DialogContent>

      <DialogActions sx={{ gap: 1, padding: 3 }}>
        <Button
          onClick={handleClose}
          variant="contained"
          disabled={insertLoading}
        >
          انصراف
        </Button>
        <LoadingButton
          variant="contained"
          color="warning"
          onClick={submitCodeGroup}
          loading={insertLoading}
        >
          اضافه کردن
        </LoadingButton>
      </DialogActions>
    </Dialog>
  );
};

export default ProductPackagingInsertModal;

const FilledWrapper = styled.div`
  display: flex;
  align-items: flex-end;
  justify-content: space-between;
  gap: 30px;
  margin-top: 30px;
`;

const FilledAreaWrapper = styled.div`
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 30px;
  margin-top: 30px;
`;

const TextArea = styled.textarea`
  resize: vertical;
  width: calc(100% - 150px);
  padding: 10px;
  border-radius: 5px;
  ${({ error }) => error && 'border: 2px solid #d32f2f;'}

  &:focus {
    outline-color: #1976d2;
  }
`;

const FilledLabel = styled.label``;
